import React from "react";
import { ControlButtons } from "../F2FUI/ControlButtons";
import { RemoteVideoView } from "../F2FUI/RemoteVideoView";
import { VideoSidebar } from "../F2FUI/VideoSidebar";
import { MeetingTimer } from "../F2FUI/MeetingTimer";
import { MeetingEndDialog } from "../F2FUI/MeetingEndDialog";
import Loader from "../../../components/commonComponents/Loader";

const F2FVideoUIPage = (props) => {
  const {
    isAdminOrCM,
    remoteRef,
    remoteVideoActive,
    isRemoteVideoOn,
    isRemoteUserInRoom,
    connected,
    hasJoined,
    isAnalyzing,
    hasAnalysisStarted,
    isVideoOn,
    isAudioOn,
    handleStartCall,
    handleJoinMeeting,
    handleAnalyzeToggle,
    handleEndCall,
    handleCloseMeeting,
    toggleVideo,
    toggleAudio,
    localRef,
    responses,
    permission,
    handleClearLogs,
    logs,
    isUploading,
    isUploadingCm,
    isMeetingEnded,
    setIsMeetingEnded,
    callStarted,
    handleStartTheCall,
    isScreenRecording,
    handleScreenRecording,
  } = props;
  return (
    // ${isAdminOrCM ? "h-full" : "min-h-screen"}
    <div
      className={`min-h-screen flex flex-col justify-center bg-white p-4 md:p-8 ${isMeetingEnded ? "blur-md pointer-events-none transition-all duration-500" : ""}`}
    >
      {isUploading && <Loader />}
      {isUploadingCm && <Loader />}
      {/* Main Content Area */}
      <div className="flex flex-col lg:flex-row items-stretch justify-center gap-8 lg:gap-12 relative max-w-7xl mx-auto w-full">
        <div className="flex-1 flex flex-col gap-6">
          {/* Main Video View (Remote) */}
          <RemoteVideoView
            remoteRef={remoteRef}
            remoteVideoActive={remoteVideoActive}
            isRemoteVideoOn={isRemoteVideoOn}
            isRemoteUserInRoom={isRemoteUserInRoom}
            isAdminOrCM={isAdminOrCM}
          />

          {/* Control Buttons Container */}
          <ControlButtons
            isAdminOrCM={isAdminOrCM}
            connected={connected}
            hasJoined={hasJoined}
            isAnalyzing={isAnalyzing}
            hasAnalysisStarted={hasAnalysisStarted}
            isVideoOn={isVideoOn}
            isAudioOn={isAudioOn}
            handleStartCall={handleStartCall}
            handleJoinMeeting={handleJoinMeeting}
            handleAnalyzeToggle={handleAnalyzeToggle}
            handleEndCall={handleEndCall}
            handleCloseMeeting={handleCloseMeeting}
            toggleVideo={toggleVideo}
            toggleAudio={toggleAudio}
            callStarted={callStarted}
            handleStartTheCall={handleStartTheCall}
            isScreenRecording={isScreenRecording}
            handleScreenRecording={handleScreenRecording}
          />
        </div>

        {/* Right Sidebar: Local Preview & Live Score */}
        <VideoSidebar
          localRef={localRef}
          isAdminOrCM={isAdminOrCM}
          responses={responses}
          isVideoOn={isVideoOn}
          permission={permission}
        />
      </div>

      {isAdminOrCM && (
        <div style={{ marginTop: 20 }}>
          <div>
            Permission: <strong>{permission}</strong>
          </div>
          <div className="flex justify-between items-center mb-1">
            <div style={{ fontWeight: "bold" }}>Logs</div>
            <MeetingTimer isAnalyzing={isAnalyzing} />
            <button
              onClick={handleClearLogs}
              className="text-xs bg-gray-200 hover:bg-gray-300 px-2 py-0.5 rounded border border-gray-400 transition-colors"
            >
              Clear Logs
            </button>
          </div>
          <div
            style={{
              maxHeight: 150,
              overflow: "auto",
              background: "#f7f7f7",
              padding: 6,
              fontSize: 12,
              border: "1px solid #ddd",
              borderRadius: 4,
            }}
          >
            <div className="">
              {logs.map((ele, idx) => (
                <div
                  style={{
                    marginRight: "8px",
                    color: "black",
                    backgroundColor: "tomato",
                    fontSize: "16px",
                    fontWeight: "bold",
                    margin: "8px",
                    padding: "10px 10px",
                  }}
                  key={idx}
                >
                  {ele}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
      {!isAdminOrCM && isMeetingEnded && (
        <MeetingEndDialog
          visible={isMeetingEnded}
          onHide={() => setIsMeetingEnded(false)}
        />
      )}
    </div>
  );
};

export default React.memo(F2FVideoUIPage);
